import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { DateFormateService } from "src/app/services/date-formate.service";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { RewardCategoryModel, RewardSubCategoryModel } from "../models/rewards";
import { TargetAchievementModel } from "../models/target-achievement";

@Injectable({
  providedIn: "root",
})
export class TargetAchievementProvider {
  page = 1;
  getPaginationCount;
  targetAchievments: TargetAchievementModel[] = [];
  targetAchievment: TargetAchievementModel;
  rewardHistory = [];
  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration,
    public router: Router,
    private formateDate: DateFormateService,
    public alertService: AlertService
  ) {}

  getTargetAchievementList(): void {
    this.apiService
      .getHeaders(this.apiConfig.getTargetAchivementList + "?page=" + this.page)
      .subscribe((res: any) => {
        this.targetAchievments = res.body.data as TargetAchievementModel[];
      });
  }

  addTarget(addTargetModel: TargetAchievementModel): boolean {
    addTargetModel.start_date = this.formateDate.formateDate(
      addTargetModel.start_date
    );
    addTargetModel.end_date = this.formateDate.formateDate(
      addTargetModel.end_date
    );
    if (
      new Date(addTargetModel.end_date) < new Date(addTargetModel.start_date)
    ) {
      this.toast.Error("End Date can't before Start date");
      return false;
    } else {
      this.apiService
        .post(this.apiConfig.addTargetAchivement, addTargetModel)
        .subscribe(
          (res: any) => {
            this.toast.Success(res.body.data.message);
            addTargetModel = res.body.data.data;
            let dates = {
              start: addTargetModel.start_date.split("-"),
              end: addTargetModel.end_date.split("-"),
            };
            let startDate = {
              year: parseInt(dates.start[0]),
              month: parseInt(dates.start[1]),
              day: parseInt(dates.start[2]),
            };
            let endDate = {
              year: parseInt(dates.end[0]),
              month: parseInt(dates.end[1]),
              day: parseInt(dates.end[2]),
            };
            this.toast.Success(res.body.data.message);
            this.alertService.success(res.body.data.message);
            this.clearSuccess();
            this.targetAchievments.push(
              addTargetModel as TargetAchievementModel
            );
            this.router.navigate(["/hubAdmin/add-target-achievements"], {
              queryParams: { targetId: addTargetModel.id },
            });
            return true;
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  updateTarget(targetModel: TargetAchievementModel): boolean {
    targetModel.start_date = this.formateDate.formateDate(
      targetModel.start_date
    );
    targetModel.end_date = this.formateDate.formateDate(targetModel.end_date);
    if (new Date(targetModel.end_date) < new Date(targetModel.start_date)) {
      this.toast.Error("End Date can't before Start date");
      return false;
    } else {
      this.apiService
        .put(
          this.apiConfig.updateTargetAchivement + "?id=" + targetModel.id,
          targetModel
        )
        .subscribe(
          (res: any) => {
            this.toast.Success(res.data.message);
            this.alertService.success(res.data.message);
            this.clearSuccess();
            let dates = {
              start: targetModel.start_date.split("-"),
              end: targetModel.end_date.split("-"),
            };
            let startDate = {
              year: parseInt(dates.start[0]),
              month: parseInt(dates.start[1]),
              day: parseInt(dates.start[2]),
            };
            let endDate = {
              year: parseInt(dates.end[0]),
              month: parseInt(dates.end[1]),
              day: parseInt(dates.end[2]),
            };
            this.targetAchievments.push(targetModel as TargetAchievementModel);
            this.router.navigate(["/hubAdmin/add-target-achievements"], {
              queryParams: { targetId: targetModel.id },
            });
            return true;
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  getTargetPageCount(): void {
    this.apiService
      .getHeaders(this.apiConfig.getTargetAchivementList)
      .subscribe((res: any) => {
        this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
        console.log("here", res.headers);
      });
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }
}
